export const isObject = value => {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};
